module.exports = __webpack_public_path__ + "img/car.1fd66d0f.png";